import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Components/Avatar';

import { toast } from '../toast';
import utils from './utils';

class Reply extends React.Component {
    state = { processing: false };

    deleteReply = () => {
        if (this.state.processing) return Promise.reject();

        this.props.commentsStore.confirmDelete()
            .then(() => {
                this.setProcessing(true);

                this.props.commentsStore.api.deleteReply(
                    this.props.commentsStore.resource,
                    this.props.comment.id
                )
                    .then(res => {
                        this.props.parent.replies.pop();
                        const updatedComment = this.props.parent.toRaw();
                        this.props.commentsStore.replaceComment(updatedComment);
                    })
                    .catch(err => toast('ERROR_OCCURED'))
                    .then(() => this.setProcessing(false));
            });
    };

    editReply = () =>
        this.props.expandedComponent.setReplyEditing(this.props.comment);

    setProcessing = value => this.setState({ processing: value });

    renderAuthorActions = () =>
        (<div className='btn-column'>
            <span className='author-actions'>
                <span
                    className='icon icon-edit'
                    title={gettext('Edit')}
                    onClick={this.editReply}
                    ga-action={this.props.commentsStore.GASettings.action}
                    ga-label='Edit_Reply'
                    data-what='reply-action'
                    data-which='edit'
                />
                <span
                    className='icon icon-delete'
                    title={gettext('Delete')}
                    onClick={this.deleteReply}
                    ga-action={this.props.commentsStore.GASettings.action}
                    ga-label='Delete_Reply'
                    data-what='reply-action'
                    data-which='reply'
                />
            </span>
        </div>);

    render () {
        const { comment } = this.props;

        return comment
            ? (<div className='comment-simple'>
                <div className='comment-one-liner'>
                    <Avatar
                        name={comment.author}
                        email={comment.owner.email}
                        login={comment.owner.login}
                        classes={'comment-avatar'}
                    />
                    <div className='comment-column'>
                        <div className='posted-info'>
                            <span className='user' data-what='reply-author'>
                                {comment.author}
                            </span>
                            <span className='pub-date' data-what='reply-date'>
                                {comment.published }
                            </span>
                        </div>
                        <div
                            className='content comment-text'
                            dangerouslySetInnerHTML={utils.createMarkup(comment.content)}
                            data-what='reply-body'
                        />
                    </div>
                    {
                        comment.owner.login === Settings.user.login &&
                        utils.checkUpdatePermission(comment.data.pub_date) &&
                            this.renderAuthorActions()
                    }
                </div>
            </div>)
            : null;
    };
}

export default Reply;

Reply.propTypes = {
    comment: PropTypes.object,
    parent: PropTypes.object,
    expandedComponent: PropTypes.object,
    commentsStore: PropTypes.object.isRequired
};
